export default "__VITE_ASSET__HzNsqeM0__"